import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, take, tap, filter } from 'rxjs/operators';
import { MainDowngradeService } from '../pages/subscription/subscription-downgrade/services/main-downgrade.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DowngradeCleanupComponent } from '../pages/subscription/subscription-downgrade/modals/downgrade-cleanup/downgrade-cleanup.component';
import { CurrentUserService } from '../services/current-user.service';

@Injectable({
  providedIn: 'root'
})
export class DowngradeGuard implements CanActivate {

  constructor(
    private downgradeService: MainDowngradeService,
    private modalService: NgbModal,
    private currentUserService: CurrentUserService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> {

    return this.currentUserService.currentUser.pipe(
      take(1),
      switchMap((user: any) => {
        if (!user || !user.id) {
          return of(true); // Let authGuard handle unauthenticated access
        }

        return this.downgradeService.downgradeStatus$.pipe(
          tap((response) => {
            if (!response) {
              this.downgradeService.loadDowngradeStatus(user.id);
            }
          }),
          filter(response => !!response),
          take(1),
          map((response: any) => {
            if (response && response.cleanup_required) {
              // Open the downgrade cleanup modal forcefully
              if (!this.modalService.hasOpenModals()) {
                const modalRef = this.modalService.open(DowngradeCleanupComponent, {
                  centered: true,
                  size: 'md',
                  backdrop: 'static',
                  keyboard: false
                });
                modalRef.componentInstance.userId = user.id;
                modalRef.componentInstance.downgradeResponse = response;
                modalRef.componentInstance.upgradePlan = response.to_plan;
                modalRef.componentInstance.currentPlan = response.from_plan;
              }
              // Redirect to home or stay on current un-guarded route (like login)
              return this.router.parseUrl('/home');
            }
            return true;
          }),
          catchError(() => {
            // If the service fails, assume no pending downgrade
            return of(true);
          })
        );
      })
    );
  }
}
